import { render, staticRenderFns } from "./NewDiagnosisDialog.vue?vue&type=template&id=5ed0ffe4&"
import script from "./NewDiagnosisDialog.vue?vue&type=script&lang=js&"
export * from "./NewDiagnosisDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDialog,VDivider,VIcon})
